<template>
    <audio style="height: 0" id="bgm" ref="bgm" preload="auto" :loop="isRandom=='circle'" v-if="curInfo"  :src="curInfo.src" @canplay="audioCanPlay" @durationchange='audioChange'  @timeupdate="updateTime" @ended ="audioEnd" @loadedmetadata="loadALl" ></audio>
</template>

<script>
import { mapState,mapGetters,mapMutations } from 'vuex';
import wx from "weixin-js-sdk"
export default {
  name: '',
  props: { },
  data(){
    return{
       timing:null
    }
  },
  
  computed:{
    ...mapGetters("audio", {
      curInfo: "getCurAudio",
    }),
    ...mapState("audio",{
      audioPlay:"playState",
      isRandom:"playOrder"
    }),
  },
  watch:{
    audioPlay:{
      handler(newv,oldv){
        this.changeAudioState()
      },immediate:true
    },
    curInfo:{
      handler(newv,oldv){
        if(newv){
          // this.watchAudio()
          this.playerNow()
        }
      },immediate:true
    }
  },
  methods:{
    ...mapMutations(['audio/updateDuration','audio/updateCurTime','audio/updatePlayState','audio/audioEnd','audio/updatePlayInfo']),
    loadALl(e){
      // console.log(e);
      this.playAudio()
    },
    playerNow(){
      
      wx.config({
        debug: false,
        appId: "",
        timestamp: 1,
        nonceStr: "",
        signature: "",
        jsApiList: [],
      });
      wx.ready(function () {
        // alert("sss")
        let music = document.getElementById("bgm")
        music.play(); 
                
      });
    },

    audioCanPlay(){
      let music = document.getElementById("bgm");
        // this.audioDuration = music.duration;
        this['audio/updateDuration'](parseInt(music.duration))
        this['audio/audioEnd'](false)
        if(this.audioPlay){
          this.playAudio()
        } 
    },

    timerC(){
        let music = document.getElementById("bgm");
     this.timing =  setInterval(()=>{
        // console.log("播放");
        if(!music.paused){
          this.$refs.bgm && this.$refs.bgm.play();
          this['audio/updatePlayState'](true)
          this.timing = null
        }else{
          this['audio/updatePlayState'](false)
          this.playAudio()
        }
      },1000)
    },

    audioChange(){
    },
    updateTime(){
      let music = this.$refs.bgm;
      this['audio/updateCurTime'](parseInt(music.currentTime))
    },
    audioEnd(e){
      // this.next()
      this['audio/audioEnd'](true)
      // console.log('播放下一曲');
      
    },

    playAudio(){
      let music = document.getElementById("bgm");
      if(!music) return
        this.$refs.bgm && this.$refs.bgm.play();
        if(music.paused){
          this['audio/updatePlayState'](false)
          !this.timing && this.timerC()
        }else{
          clearInterval(this.timing)
          this['audio/updatePlayState'](true)
        }

      
    },

    //音频播放与暂停事件
    changeAudioState(){
      if(this.audioPlay){
        this.$refs.bgm && this.$refs.bgm.play();
        clearInterval(this.timing)
      }else{
        this.$refs.bgm && this.$refs.bgm.pause();
        
      }
    },

    stopAudioHome(){
      clearInterval(this.timing)
      this['audio/updatePlayState'](false)
      this['audio/updatePlayInfo'](null)
    }

  },
}
</script>
<style scoped lang="scss">


</style>